module.exports = __webpack_public_path__ + "img/prize-locked.94800ff2.svg";